import React from "react";
import { PropTypes } from "prop-types";
//Material imports
import Button from "@mui/material/Button";
import ListSubheader from "@mui/material/ListSubheader";
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import Refresh from "@mui/icons-material/Refresh";
import FilterList from "@mui/icons-material/FilterList";
//Limitless imports
import { withi18n } from "@limitless/customer/components";
import TaskListFilters from "../task-list-filters/TaskListFilters";
import { useTaskListFilter } from "@limitless/expert";

const TaskListHeader = ({ classes, refreshHandler, t, activeFilterCount }) => {
    const [filterExpand, setFilterExpand] = React.useState(false);
    const [dropDownFocus, setDropDownFocus] = React.useState(false);
    const [filterCompHeight, setFilterCompHeight] = React.useState(0);
    const { renderFilterLabel } = useTaskListFilter();

    const filterComponentUpdate = newHeight => {
        setFilterCompHeight(newHeight);
    };

    const heightStyles = {};

    if (filterExpand) {
        heightStyles.height = filterCompHeight + 67;
    }

    return (
        <ListSubheader
            component="div"
            style={heightStyles}
            className={`${dropDownFocus ? classes.expand : ""} ${classes.rootContainer} ${classes.filterAni}`}
        >
            <div className={classes.subtRootContainer}>
                <Button id="refreshBtn" className={classes.iconButtonStyle} onClick={refreshHandler}>
                    <Refresh />
                </Button>
                <div className={classes.subContainer}>
                    <Button
                        id="filterBtn"
                        variant="text"
                        className={classes.buttonRoot}
                        onClick={() => setFilterExpand(!filterExpand)}
                    >
                        <Typography color={activeFilterCount > 0 ? "primary" : "inherit"}>
                            {renderFilterLabel(t, activeFilterCount)}
                        </Typography>
                        <FilterList className={classes.setMargin} />
                    </Button>
                </div>
            </div>
            <TaskListFilters
                filterComponentUpdate={filterComponentUpdate}
                closeFiltersFacet={() => setFilterExpand(!filterExpand)}
                onDropDownFocus={() => setDropDownFocus(!dropDownFocus)}
                isFilterExpanded={filterExpand}
            />
        </ListSubheader>
    );
};

const styles = theme => ({
    rootContainer: {
        display: "flex",
        position: "sticky",
        width: "100%",
        height: 67,
        overflowY: "hidden",
        flexDirection: "column",
        justifyContent: "space-between",
        margin: 0,
        padding: 0,
        borderBottom: theme.palette.seperator,
        zIndex: 0
    },
    subtRootContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        minHeight: 67
    },
    filterAni: {
        transitionProperty: "height",
        transitionDuration: "0.3s",
        animationTimingFunction: "cubic-bezier(0.5, 0.2, 0.9, 0.4)"
    },
    expand: {
        overflowY: "unset",
        zIndex: 1
    },
    subContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    iconButtonStyle: {
        width: 40,
        height: 40,
        minWidth: 40,
        padding: "2px",
        color: theme.palette.primary.dark
    },
    setMargin: {
        marginLeft: "10px"
    },
    sticky: {
        backgroundColor: "#ffffff"
    },
    buttonRoot: {
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.03)"
        },
        color: theme.palette.primary.dark
    }
});

export default withStyles(styles)(withi18n(TaskListHeader));

TaskListHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    refreshHandler: PropTypes.func,
    activeFilterCount: PropTypes.number.isRequired
};
